export const healiaryPrivacyTitles = [
  ["구분", "처리항목", "처리목적"],
  ["보존 근거", "보존 대상", "보존 기간"],
];
export const healiaryPrivacyRows = [
  [
    [
      "회원가입 (개인) 본인인증으로 가입",
      "(필수) 이름, 나이, 성별,   휴대전화번호, 사용자의 분류,   필요한 서비스의 분류",
      "회원 가입의사 확인,   식별∙인증, 회원자격 유지∙관리,   본인확인, 서비스 부정이용 확인 및 방지,  각종 고지∙통지, 고충처리,   서비스 제공 및 상담,   만 14세 이상 확인, 만족도 조사",
    ],
    [
      "나의 질병정보",
      "암의 치료 단계, 암종, 암의 병기,   수술 여부, 수술 종류, 수술 날짜,   항암치료 여부, 항암치료 종류,   항암치료 차수, 투약 항암제,   항암제 투약 경로, 치료 의료기관,   만성질환 이환, 기타 약물 복용,   일주일 간 발생하는 신체증상",
      "건강관리 등 제반 서비스 이용 시 맞춤형 건강관리 서비스 제공",
    ],
    [
      "나의 신체, 식습관 정보",
      "키, 체중, 식사시 문제점, 알레르기 여부, 유당불내증 여부, 섭취 가능한 유제품 여부, 하루 식사 횟수(아침 식사 여부), 하루 간식 횟수, 식사 담당 여부, 건강기능식품 섭취, 흡연, 음주, 식사 섭취 속도, 음식 선호도, 식사, 간식 섭취 기록, 수분섭취, 기분",
      "t0b0",
    ],
    [
      "커뮤니티 이용",
      "게시글",
      "회원의 서비스 만족도 평가, 회원 정보 통계 및 분석",
    ],
    [
      "서비스 이용 시 자동 생성되는 정보",
      "서비스 이용 기록, 접속 로그, 쿠키, 접속IP 주소, 기기고유번호(등록번호, 디바이스 아이디 또는 IMEI), 불량 이용 기록, 광고식별자, 사용 이동통신사",
      "서비스/상품 이용 정보 통계 및 분석",
    ],
    [
      "이벤트 응모 및 상담신청",
      "(필수) 이름, 휴대전화번호(선택) 성별, 생년월일",
      "이벤트 및 혜택 알림 정보 등 마케팅 ∙ 광고 활용, 서비스/신상품이나 이벤트 정보 안내, 이벤트 경품 배송",
    ],
  ],
  [
    ["상법", "상업장부와 영업에 관한 중요서류에 포함된 개인정보", "10년"],
    ["t0b0", "전표 또는 이와 유사한 서류에 포함된 개인정보", "5년"],
    [
      "국세기본법",
      "성명, 주민번호, 전화번호, 주소 등 거래에 관한 장부 및 증거서류",
      "5년",
    ],
    [
      "통신비밀보호법",
      "통신사실확인자료 제공에 필요한 성명, 주민번호, 전화번호 및 가입자의 전기통신일시, 전기통신개시ㆍ종료시간, 발ㆍ착신 통신번호 등 상대방의 가입자번호, 사용도수, 발신기지국의 위치정보",
      "12개월 단, 시외/시내전화 역무와 관련된 자료: 6개월",
    ],
    [
      "t0b0r0",
      "컴퓨터통신 또는 인터넷의 로그기록자료, 정보통신기기의 위치를 확인할 수 있는 접속지의 추적자료",
      "3개월",
    ],
    [
      "전자상거래 등에서의 소비자보호에 관한 법률",
      "계약 또는 청약철회 등에 관한 기록",
      "5년",
    ],
    ["t0b0r0", "대금결제 및 재화 등의 공급에 관한 기록", "5년"],
    ["t0b0r0", "소비자의 불만 또는 분쟁처리에 관한 기록", "3년"],
    ["t0b0r0", "표시/광고에 관한 기록", "6개월"],
    [
      "신용정보의 이용 및 보호에 관한 법률",
      "신용정보의 수집/처리 및 이용 등에 관한 기록",
      "3년",
    ],
  ],
];
